module.exports = __webpack_public_path__ + "static/media/DqEveryChildWorkshopTeacherTraining.e75d914d.jpg";